export default __webpack_public_path__ + "static/inspire_you-64eb48fdbea85745b91567f87729ee88.jpg";